














import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class PageContent extends Vue {
  @Prop() private visible: boolean;
  @Prop() private title: string;
  @Prop() private imagePath: string;
  @Prop() private imageRaw: Blob;

  private visibleDialog = false;
  private imageStyle = {
    width: 'auto',
    height: 'auto',
  };

  private created() {
    this.visibleDialog = this.visible;
  }

  private mounted() {
    this.addEventListener();
  }

  private destroyed() {
    this.removeEventListener();
  }

  private addEventListener() {
    window.addEventListener('resize', this.onResize);

    this.onResize();
  }

  private removeEventListener() {
    window.removeEventListener('resize', this.onResize);
  }

  private async onResize() {
    const img = this.$refs.img as HTMLImageElement;

    while (!img.complete) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }

    const imageWidth = img.naturalWidth;
    const imageHeight = img.naturalHeight;

    const el = this.$el.getElementsByClassName('image')[0];
    const clientWidth = el.clientWidth - 20;
    const clientHeight = el.clientHeight - 20;

    const xScale = imageWidth / clientWidth;
    const yScale = imageHeight / clientHeight;
    if (xScale > 1 && yScale > 1) {
      if (xScale > yScale) {
        this.imageStyle = {
          width: clientWidth + 'px',
          height: 'auto',
        };
      } else {
        this.imageStyle = {
          width: 'auto',
          height: clientHeight + 'px',
        };
      }
    } else if (xScale > 1) {
        this.imageStyle = {
          width: clientWidth + 'px',
          height: 'auto',
        };
    } else if (yScale > 1) {
        this.imageStyle = {
          width: 'auto',
          height: clientHeight + 'px',
        };
    } else {
        this.imageStyle = {
          width: 'auto',
          height: 'auto',
        };
    }
  }

  private onClick() {
    this.visibleDialog = false;
    this.$emit('update:visible', this.visibleDialog);
  }

  private onImageDownload() {
    if (!(window.navigator as any).msSaveOrOpenBlob) {
      const link = document.createElement('a');
      link.href = this.imagePath;
      link.setAttribute('download', this.title);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else if (!!this.imageRaw) {
      const url = (window.navigator as any).msSaveOrOpenBlob(this.imageRaw, this.title);
    }
  }
}
